import api from "./Api";

class TabelaCombustiveisMonofasicaService {
  GetTabelaCombustiveisMonofasica(payload) {
    return api
      .get("/v1/tabelaCombustiveisMonofasica/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostTabelaCombustiveisMonofasica(payload) {
    return api
      .post("/v1/tabelaCombustiveisMonofasica/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutTabelaCombustiveisMonofasica(payload) {
    return api
      .put("/v1/tabelaCombustiveisMonofasica/", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeleteTabelaCombustiveisMonofasica(payload) {
    return api
      .delete("/v1/tabelaCombustiveisMonofasica/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetTabelaCombustiveisMonofasicaOData(payload) {
    return api
      .get("/OData/TabelaCombustiveisMonofasica" + payload)
      .then((response) => {
        return response.data;
      });
  }

  AtualizarTabelaCombustiveisMonofasica(payload) {
    return api
      .post(
        "/v1/tabelaCombustiveisMonofasica/AtualizarTabelaCombustiveisMonofasica",
        payload
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new TabelaCombustiveisMonofasicaService();
